import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { User } from '@xpo-ltl/sdk-common';
import { OffBillIncentiveApiService } from '@xpo-ltl/sdk-offbillincentive';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppRoutes } from '@enums/app-routes.enum';
import { UserRoleService } from '@services/user-role/user-role.service';

@Injectable({
  providedIn: 'root',
})
export class NotAuthorizedRedirectGuard implements CanActivate {
  constructor(
    private obiApiService: OffBillIncentiveApiService,
    private router: Router,
    private userRoleService: UserRoleService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.obiApiService.loggedInUser().pipe(
      map((user: User) => {
        this.userRoleService.user = user;
        if (this.userRoleService.isAuthorizedUser()) {
          this.router.navigate([AppRoutes.LANDING_PAGE]);
          return true;
        }
        this.userRoleService.user = undefined;
        return true;
      })
    );
  }
}
